<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        ข้อผิดพลาดในการนำเข้าข้อมูล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> ข้อผิดพลาดในการนำเข้าข้อมูล
          </a>
        </li>
        <li class="active">ข้อผิดพลาดในการนำเข้าข้อมูล</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <h3 class="box-title">ข้อผิดพลาดในการนำเข้าข้อมูล</h3>
              </div>
              <div class="box-body">
                <div class="wrapper_alert_promotion">
                  <h2>ข้อมูลที่ผิดพลาด</h2>
                  <h4 
                  v-for="(item,index) in errorList"
                  :key="index">{{ 1+index +'. ' + item}}</h4>
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="success"
                    @click="backtouploadfile"
                  >กลับสู่หน้าการนำเข้าข้อมูล</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions } from 'vuex';
export default {
  computed: {
    ...mapState({
      errorList : store => store.Manage_internet.errors,
      forwardPath : store => store.Manage_internet.forward_path
    })
  },
  methods: {
    ...mapActions({
      cancel : "Manage_internet/cancelUpload"
    }),
    backtouploadfile() {
      this.cancel()
      this.$router.push({ name: this.forwardPath });
    }
  }
};
</script>
